class SideMenuComponent extends HTMLElement {
  constructor() {
    super();
    this.menuToggle = null;
    this.menuCloseButtons = null;
    this.resetButton = null;
    this.mobileMenu = null;
    this.overlay = null;
    this.filterForm = null;
  }

  connectedCallback() {
    this.menuToggle = this.querySelector('[data-ref="sidebar-toggle"]');
    this.menuCloseButtons = this.querySelectorAll('[data-ref="sidebar-close"]');
    this.resetButton = this.querySelector('[data-ref="sidebar-reset"]');
    this.mobileMenu = this.querySelector('[data-ref="sidebar-menu"]');
    this.overlay = this.querySelector('[data-ref="sidebar-overlay"]');
    // On cherche le formulaire qui contient les filtres
    this.filterForm = this.querySelector('[data-ref="filters-form"]');

    this.menuToggle?.addEventListener('click', this.#handleMenuOpen);

    // Ajout de l'écouteur sur tous les boutons de fermeture trouvés
    this.menuCloseButtons.forEach((btn) => {
      btn.addEventListener('click', this.#handleMenuClose);
    });

    this.resetButton?.addEventListener('click', this.#handleReset);
    this.overlay?.addEventListener('click', this.#handleOverlayClick);
    document.addEventListener('keydown', this.#handleKeyDown);
  }

  disconnectedCallback() {
    this.menuToggle?.removeEventListener('click', this.#handleMenuOpen);
    this.menuCloseButtons?.forEach((btn) => {
      btn.removeEventListener('click', this.#handleMenuClose);
    });
    this.resetButton?.removeEventListener('click', this.#handleReset);
    this.overlay?.removeEventListener('click', this.#handleOverlayClick);
    document.removeEventListener('keydown', this.#handleKeyDown);
  }

  #handleMenuOpen = () => {
    this.open();
  };

  #handleMenuClose = () => {
    this.close();
  };

  #handleReset = () => {
    if (this.filterForm) {
      this.filterForm.reset();
      // Si votre site utilise une soumission automatique au clic (AJAX),
      // vous pouvez déclencher un événement 'input' pour mettre à jour la page :
      // this.filterForm.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };

  #handleOverlayClick = (event) => {
    if (event.target === this.overlay) {
      this.close();
    }
  };

  #handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.overlay.classList.contains('is-open')) {
      this.close();
    }
  };

  open() {
    this.overlay.classList.remove('is-closing');
    this.overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      this.menuCloseButtons?.[0]?.focus();
    }, 150);
  }

  close() {
    this.overlay.classList.add('is-closing');

    setTimeout(() => {
      this.overlay.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
      this.menuToggle?.focus();
    }, 125);
  }
}

if (!customElements.get('side-menu-component')) {
  customElements.define('side-menu-component', SideMenuComponent);
}